module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0008.7cdb30aa.jpg";